import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { SubmitButton } from '../lib/Button';
import dashboard from './dashboard';
import { ActionHeader } from './dashboard/makeNct';
import { Dialog, Divider, makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { validatePanForAmfiCas } from '../redux-store/actions/link';
import { useDispatch } from 'react-redux';
import en from '../lang/en-us';
/*************  ✨ Codeium Command ⭐  *************/
/**
 * AMFICAS is a React component that displays a confirmation message
 * when the user requests an RTA CAS.
 *
 * @param {object} props The component props.
 * @returns {ReactElement} A React element representing the component.
 */
/******  d23da9ba-ee2e-418e-a649-dada67d8c039  *******/

const {
    login: { quickLinks, applyPan, form: LoginForm },
    signUp: { form: SignupForm },
} = en;

const useStyles = makeStyles({
    customFocusButton: {
        '&:focus': {
            outline: 'none',
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: 'rgba(27, 94, 32, 0.08)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(27, 94, 32, 0.15)',
            transition: 'all 0.2s ease-in-out',
        },
        '& .MuiButton-root': {
            '&:focus': {
                outline: 'none',
                boxShadow: 'none',
            },
        },
        '&.Mui-focusVisible': {
            outline: '3px solid #F9A825 !important',
            outlineOffset: '3px',
            boxShadow: '0 0 0 6px rgba(249, 168, 37, 0.12) !important',
            backgroundColor: '#F9A825 !important',
            color: '#000000 !important',
            transform: 'translateY(-1px)',
            transition: 'all 0.2s ease-in-out',
            '& .MuiTouchRipple-root': {
                display: 'none !important',
            },
        },
        '&.Mui-focusVisible.MuiButton-root': {
            backgroundColor: '#F9A825 !important',
            color: '#000000 !important',
            '& span': {
                color: '#000000 !important',
            },
        },
        '& .MuiTouchRipple-root': {
            display: 'none !important',
        },
        transition: 'all 0.2s ease-in-out',
        border: '2px solid transparent',
        '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 2px 4px rgba(27, 94, 32, 0.2)',
        },
    },
    '@global': {
        '.custom-focus-button.Mui-focusVisible': {
            backgroundColor: '#F9A825 !important',
            color: '#000000 !important',
            '& .MuiButton-label': {
                color: '#000000 !important',
            },
            '& span': {
                color: '#000000 !important',
            },
        },
    },
});

function AMFICAS() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const queryParams = location.search;

    const parsedQueryParams = new URLSearchParams(queryParams);

    const token = parsedQueryParams.get('token');

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);

    useEffect(() => {
        async function callApi() {
            await validatePanForAmfiCas({
                reqId: '',
                encryptRequest: token,
            })(dispatch);
        }
        callApi().catch((error: any) => {
            alert(error.message);
        });
    }, [token]);
    return (
        <div className="curved-bg quick-links-content">
            <div className="curved-bg-inner">
                <div className="curved-bg-content request-box">
                    <div className="curved-bg-content-inner">
                        <div className="curved-bg-content-inner-top">
                            <div className="request-box-content">
                                <div
                                    className="request-box-mail-mobile"
                                    style={{ marginBottom: '20px' }}
                                >
                                    <img src="/images/Send-Mail.svg" alt="" />
                                </div>
                                <div className="request-box-text-content">
                                    <p>
                                        We have successfully received your request for the RTA CAS.
                                        An email attached with your CAS will be sent to the
                                        registered email address linked to your folio within the
                                        next 15 minutes.
                                    </p>
                                </div>
                                <div className="request-box-mail">
                                    <img src="/images/Send-Mail.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="journey-today">
                    <div className="journey-today-header">
                        <p
                            style={{
                                fontSize: '30px',
                                fontWeight: 'bold',
                                color: '#fff',
                                margin: 0,
                            }}
                        >
                            Start your Investment Journey Today
                        </p>
                    </div>
                    <Divider orientation="horizontal" color="#FFF" />
                    <div className="journey-today-content" style={{ marginLeft: '20px' }}>
                        <p>
                            MF Central is an investor services hub developed by KFintech and CAMS,
                            designed to streamline transactions across all your folios with ease.
                        </p>
                        <div className="journey-today-button">
                            <Button
                                onClick={() => {
                                    history.push('/');
                                }}
                                className={classes.customFocusButton}
                                disableRipple={true}
                                disableFocusRipple={true}
                                disableElevation={true}
                            >
                                Visit MF Central
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="quick-links">
                <div className="quick-links-header">
                    <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#333', margin: 0 }}>
                        Quick Links
                    </h2>
                </div>
                <ul role="list" className="quick-links-list" tabIndex={0}>
                    <li role="listitem" className="quick-link-blocks update-pan">
                        <img src="/images/update-pan-1.svg" alt="" />
                        <p
                            role="link"
                            tabIndex={0}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                history.push('/links/update-pan');
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    history.push('/links/update-pan');
                                }
                            }}
                        >
                            Update PAN
                        </p>
                    </li>
                    <li role="listitem" className="quick-link-blocks apply-pan">
                        <img src="/images/apply-pan-1.svg" alt="" />
                        <p
                            role="link"
                            tabIndex={0}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setShow(true);
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setShow(true);
                                }
                            }}
                        >
                            Apply for PAN
                        </p>
                    </li>
                    <li role="listitem" className="quick-link-blocks tranmission-request">
                        <img src="/images/trans-request.svg" alt="" />
                        <p
                            role="link"
                            tabIndex={0}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                history.push('/links/transmission-request');
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    history.push('/links/transmission-request');
                                }
                            }}
                        >
                            Transmission Request
                        </p>
                    </li>
                    <li role="listitem" className="quick-link-blocks rupee">
                        <img src="/images/rupee.svg" alt="" />
                        <p
                            role="link"
                            tabIndex={0}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                history.push('/links/transfer-of-units');
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    history.push('/links/transfer-of-units');
                                }
                            }}
                        >
                            Transfer of units
                        </p>
                    </li>
                    <li role="listitem" className="quick-link-blocks mitra">
                        <img src="/images/mitra.svg" alt="" />
                        <p
                            role="link"
                            tabIndex={0}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                history.push('/links/mitra');
                            }}
                            onKeyDown={(e: React.KeyboardEvent) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    history.push('/links/mitra');
                                }
                            }}
                        >
                            MITRA
                        </p>
                    </li>
                </ul>
            </div>
            <Dialog fullWidth maxWidth={'md'} open={show} aria-labelledby="applyPanModal">
                <div className="applyPanModal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 id="applyPanModal" className="modal-title">{applyPan.heading}</h4>
                                <a
                                    role="button"
                                    tabIndex={0}
                                    aria-label="Close dialog"
                                    onClick={() => setShow(!show)}
                                    onKeyDown={(e: React.KeyboardEvent) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setShow(!show);
                                        }
                                    }}
                                >
                                    <img src="/images/close-black.svg" alt="Close" />
                                </a>
                            </div>
                            <div className="modal-body">
                                <h6>{applyPan.info}</h6>
                                <h6>{applyPan.infoBottom}</h6>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment.svg"
                                        alt=""
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/nsdl.png" alt="" />
                                    </div>
                                    <p>NSDL</p>
                                    <a
                                        href="https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-links">
                                    <img
                                        src="/images/attachment2.svg"
                                        alt=""
                                        className="pan-attachment-img"
                                    />
                                    <div className="pan-website-img">
                                        <img src="/images/utiitsl.png" alt="" />
                                    </div>
                                    <p>UTIITSL</p>
                                    <a
                                        href="https://www.pan.utiitsl.com/PAN/mainform.html"
                                        target="_blank"
                                    >
                                        {applyPan.clickHere}
                                    </a>
                                </div>
                                <div className="pan-info">
                                    <p>
                                        {applyPan.websiteInfo}{' '}
                                        <a
                                            href="https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx"
                                            target="_blank"
                                        >
                                            https://www.incometaxindia.gov.in/Pages/tax-services/apply-for-pan.aspx
                                        </a>{' '}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
export default AMFICAS;
